module.exports = __webpack_public_path__ + "img/94.c0a77b5c.png";